import { i18n } from 'core/i18n';
import { MODAL_STATIC_CONTENT } from '../constants/account';

const { formatText } = i18n;

export const getAccountProducts = (immAccounts, accountId) => {
    const immAccount = immAccounts.getIn(['byId', accountId]);

    if (!immAccount) {
        return {
            oldContract: {},
            newContract: {}
        }
    }

    const { newProduct, product, contractNumber, newContractNumber } = immAccount.toJS();
    return {
        oldContract: {
            product,
            contractNumber,
        },
        newContract: {
            product: newProduct,
            contractNumber: newContractNumber,
        }
    }
}

export const getStaticContent = (optionSelected) => {
    return MODAL_STATIC_CONTENT[optionSelected] || {}
}

export const getPrimaryButtonText = ({ responseButtonName, optionSelected }, isServiceFailed) => {
    const { errorPrimaryButtonText } = getStaticContent(optionSelected);
    if (isServiceFailed) {
        return formatText(errorPrimaryButtonText);
    }
    return responseButtonName || formatText('common-understood');
}

export const getValidationMessage = () => {
    if (isValidationSuccess) {
        return {};
    }

    const validationMessage = immAccountValidation.get('validationMessage');
    return {
        titleText: validationMessage.get('titleText'),
        descriptionText: validationMessage.get('descriptionText'),
        buttonText: validationMessage.get('buttonText'),
        navigationFlowConfirmationButton: validationMessage.get('navigationFlowConfirmationButton')
    };
}
